import { Component, Input, ViewEncapsulation, OnInit } from "@angular/core";
import _Crypttp from 'crypttp';
const css = require('./crypttp.style.css').toString()

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: "crypttp",
    styles: [
        `${css}`
    ],
    template: `
    <div
        class="crypttp-container-fixed-width"
        [style.max-width]="buttonWidth"
    >
        <button
            class="embed-one-click-crypttp-button"
            (click)="proceedCheckout()"
            [style.background]="finalButtonColor"
            [style.color]="fontColor"
        >
            <img class="crypttp-logo-image-placeholder" src="{{image}}"/>
            {{finalButtonText}}
        </button>

        <div [style.display]="display_loader" class="crypttp-loader">
            <svg viewBox="0 0 80 80">
                <circle name="crypttp-loader" cx="40" cy="40" r="32"></circle>
            </svg>
        </div>
    </div>
    `
})
export class AppComponent {
    @Input() buttonText: string;
    @Input() buttonColor: string;
    @Input() buttonWidth: string;
    @Input() type: string;
    @Input() merchant_id: string;
    @Input() country_currency: string;
    @Input() currency: string;
    @Input() amount: string;
    @Input() payload: string;
    @Input() memo: string;
    @Input() onsuccess: string;
    @Input() onerror: string;

    display_loader: string;
    crypttp: _Crypttp;
    title = 'crypttp-angular';
    finalButtonColor: string;
    fontColor = "#FFF";
    finalButtonText: string;
    image: string;

    constructor() {
        this.crypttp = new _Crypttp();
        this.displayLoader();
    }

    ngOnInit() {
        this.finalButtonText = (!this.buttonText || typeof this.buttonText == "undefined") ? "Instant payment" : this.buttonText

        if (typeof this.buttonColor != 'undefined')
            if (parseInt(this.buttonColor.split('#')[1], 16) > 13224393) {
                this.finalButtonColor = this.buttonColor
                this.fontColor = "#000"
                this.image = "https://i.imgur.com/RZJ1r6X.png"
            }
            else {
                this.finalButtonColor = this.buttonColor
                this.image = "https://i.imgur.com/gtOApwq.png"
            }
    }

    proceedCheckout () {
        this.displayLoader()

        let orderDetails = {
            type: this.type,
            merchant_id: this.merchant_id,
            country_currency: this.country_currency,
            currency: this.currency,
            amount: this.amount,
            payload: this.payload,
            memo: this.memo,
            onsuccess: this.onsuccess,
            onerror: this.onerror
        }
        
        this.crypttp.pay(orderDetails)

        setTimeout(() => {
            this.displayLoader()
        }, 1500)
    }

    displayLoader () {
        if (this.display_loader == "none")
            this.display_loader = "block"

        else
            this.display_loader = "none"
    }
}